<template>
<div>
  <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else class="invoice-create-page">
    <!--  credit form component -->
    <PaymentReceivedForm
      page="create"
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      v-on:FormUpdate="FormUpdate = 1"
      v-on:onSubmit="onSubmit($event)"
    ></PaymentReceivedForm>
  </div>
</div>
</template>

<script>
import PaymentReceivedForm from "@/components/Form/PaymentsReceived/PaymentReceivedForm"; // credit form for create and update
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  name: "PaymentCreate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    PaymentReceivedForm,
    RecordNotFound
  },
  data() {
    return {
      FormUpdate: 0,
      duplicatecode: false,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("payment/createList", data)
        .then((response) => {
          this.FormUpdate = 0; // to hide before route leave confirmation message

          this.submitted = false;
          if (this.status_code == 200) {
             var saved_data = JSON.parse(data);
            if (saved_data.header_details.pymnt_desc_changed) {
              this.pymnt_settings_details.cus_inv_notes =
                saved_data.header_details.cus_inv_notes;
            }
             //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
               message: this.status_message,
             type: this.status_type,
              showCloseButton: true
            });
             if(this.RoutePermission(false,'','invoice','paymentsreceived','index')){
            this.$router.push({ name : 'PaymentView',params:{id:this.updated_id}});
            }
            else{
              this.$router.push({ name : 'Payment'})
            }

          } else {
            this.duplicatecode = true;
            this.submitted = false;
          }
        })
        .catch(() => {});
    }
  },
 async beforeRouteEnter(routeTo, routeFrom, next) {
   await store
      .dispatch(
        "payment/fetchPaymentmethod",
        JSON.stringify({
          type: "payment_received"
        })
      )
      .then(() => {
        next();
      });
     await  store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Payments Received",
        stg_name: "pymnt_settings_details"
      })
      .then(() => {
        next();
      });

  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  updated: function() {},

  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.payment.code,
      status_code: state => state.payment.status_code, 
      status_message: state => state.payment.status_message, 
      status_type: state => state.payment.status_type,
      updated_id: state => state.payment.updated_id
    }),
    pymnt_settings_details: {
      get() {
        return this.$store.state.permission.pymnt_settings_details;
      },
      set(val) {
        this.$store.state.permission.pymnt_settings_details = val;
      }
    }
  }
};
</script> 

<style>
</style>
